<template>
  <div>
    <div align="left">
      <span style="margin-right: 5px">月度汇总报表</span>
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd">
      </el-date-picker>

      <el-select v-model="level" placeholder="医院级别" style="width: 150px" @change="buildTable">
        <el-option label="全部级别" value="all"></el-option>
        <el-option label="二级及以上" value="secondPlus"></el-option>
        <el-option label="二级以下" value="belowSecond"></el-option>
      </el-select>

      <el-button type="primary" icon="el-icon-circle-plus" :loading="loading" @click="getReport">确定</el-button>

      <el-button type="success" icon="el-icon-download" :disabled="tableData.length===0" @click="exportExcel">导出Excel</el-button>
    </div>

    <div style="margin-top: 10px">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        max-height="100%"
        :row-class-name="rowClass">
        <el-table-column
          prop="month"
          label="时间"
          width="200">
        </el-table-column>
        <el-table-column
          prop="infectious_weight"
          label="感染性废物重量（KG）"
          width="240">
          <template slot-scope="scope">
            <span :style="scope.row.infectious_weight<0?'color:#F56C6C':''">{{rowVal(scope.row.infectious_weight,1000)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="injure_weight"
          label="损伤性废物重量（KG）"
          width="240">
          <template slot-scope="scope">
            <span :style="scope.row.injure_weight<0?'color:#F56C6C':''">{{rowVal(scope.row.injure_weight,1000)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import coder from "./enum.js"
import excel from "./excel.js"
export default {
  methods: {
    toFixed2(val){
      let num=(Math.trunc(val*100)/100).toFixed(2).split('.');
      num[0]=num[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return num.join('.');
    },
    rowVal(val,divider){
      if (val===null||val===undefined||val==='') return '';
      return this.toFixed2(val/divider);
    },
    trunc2(val){
      return Math.trunc(val*100)/100;
    },
    rowClass({row}){
      if (row.isSubtotal||row.isTotal){
        return 'summary-row';
      }
      return '';
    },
    levelName(){
      if (this.level==='secondPlus') return '二级及以上';
      if (this.level==='belowSecond') return '二级以下';
      return '全部级别';
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(),
        "m+": (date.getMonth() + 1).toString(),
        "d+": date.getDate().toString(),
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
      };
      return fmt;
    },
    getReport(){
      if (this.loading){ return }
      if (this.dateRange==null||this.dateRange.length!==2||this.dateRange[0]===''||this.dateRange[1]===''){
        this.$alert('请选择日期范围', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      this.loading=true;
      window.ws.Call("W2S_MonthReport", this.dateRange[0], this.dateRange[1]);
    },
    buildTable(){
      if (this.rawRes===undefined||this.rawRes===null){ return }
      let data=[];
      if (this.level==='all'||this.level==='secondPlus'){
        data=data.concat(this.rawRes.l2||[]);
      }
      if (this.level==='all'||this.level==='belowSecond'){
        data=data.concat(this.rawRes.below_l2||[]);
      }
      if (this.level==='all'){
        let map={};
        for(let i=0;i<data.length;i++){
          let m=data[i].month;
          if (map[m]===undefined) map[m]={month:m,infectious_weight:0,injure_weight:0};
          map[m].infectious_weight+=data[i].infectious_weight;
          map[m].injure_weight+=data[i].injure_weight;
        }
        data=[];
        for(let k in map){ data.push(map[k]); }
      }
      data.sort(function(a,b){ return a.month.localeCompare(b.month); });
      let sumInf=0,sumInj=0;
      for(let i=0;i<data.length;i++){
        sumInf+=data[i].infectious_weight;
        sumInj+=data[i].injure_weight;
      }
      data.push({month:'小计', infectious_weight:sumInf, injure_weight:sumInj, isSubtotal:true});
      data.push({month:'合计', infectious_weight:sumInf+sumInj, injure_weight:'', isTotal:true});
      this.tableData=data;
    },
    exportExcel(){
      if (this.tableData.length===0){ return }
      let $this=this;
      let start=this.dateRange[0].replace(/-/g,'.');
      let end=this.dateRange[1].replace(/-/g,'.');
      let title='月度汇总报表（'+start+'-'+end+'，'+this.levelName()+'）';
      let headers=['时间','感染性废物重量（KG）','损伤性废物重量（KG）'];
      let data=this.tableData.map((d)=>[
        d.month,
        d.infectious_weight===null||d.infectious_weight===undefined||d.infectious_weight===''?'':$this.trunc2(d.infectious_weight/1000),
        d.injure_weight===null||d.injure_weight===undefined||d.injure_weight===''?'':$this.trunc2(d.injure_weight/1000)
      ]);
      excel.buildXlsxWorkbook([{name:'月度汇总报表', headers:headers, data:data, title:title}], title+'.xlsx');
    },
  },
  mounted() {
    let $this=this;
    console.log("###Page loaded !");
    let now = new Date();
    let firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    let lastDay = new Date(now.getFullYear(), now.getMonth()+1, 0);
    this.dateRange=[this.dateFormat("YYYY-mm-dd",firstDay),this.dateFormat("YYYY-mm-dd",lastDay)];
    window.ws.AddFunc("S2W_MonthReportRes",function (code,err,res) {
      console.log("S2W_MonthReportRes:",code,err,res)
      $this.loading=false;
      if (code==coder.OK){
        $this.rawRes=res||{l2:[],below_l2:[]};
        $this.buildTable();
      }else{
        $this.$alert(err+'('+code+')', '错误', {
          confirmButtonText: '确定'
        });
      }
    });
  },
  data() {
    return {
      tableData: [],
      dateRange: [],
      level:'belowSecond',
      rawRes:null,
      loading:false,
    }
  }
}
</script>

<style scoped>
  >>> .summary-row {
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/view/MonthReport.vue